/**
 * Footer Module
 * Handles the functionality of the footer accordion sections.
 * Ensures only one accordion section can be open at a time.
 * @module Footer
 */
(function () {
  /**
   * Initializes the footer accordion functionality.
   * Manages the opening/closing of accordion sections to ensure only one is open at a time.
   * @function footer
   */
  const footer = () => {
    const footerDetails = document.querySelectorAll(
      '.footer .accordion details'
    );
    footerDetails.forEach((targetDetail) => {
      targetDetail.addEventListener('click', () => {
        footerDetails.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute('open');
          }
        });
      });
    });
  };

  /**
   * Initializes the footer functionality when a Shopify section is loaded.
   */
  document.addEventListener('shopify:section:load', footer);

  // Initial footer setup
  footer();
})();
